import * as common from 'store/modules/common'
import { api } from './api'

import { hasAccessToken } from 'utils/accessToken'

export const initialState = {
  ...common.initialState,
  shouldReload: true
}

export const actionTypePrefix = 'applicationMenu'
export const actionTypes = { ...common.actionTypes(actionTypePrefix) }

export const actionCreators = {
  get: () => (dispatch, getState) => {
    if (hasAccessToken()) {
      const { applicationMenu } = getState()
      if (applicationMenu.shouldReload && applicationMenu.fetching !== true) {
        dispatch(actionCreators.reload())
      }
    }
  },
  reload: () => ({
    type: actionTypes.entity,
    payload: () => api.get()
  })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.entity + common.suffix.fetching: return { ...state, fetching: true, shouldReload: false }

    default: return common.reducer(state, action, actionTypePrefix)
  }
}
